// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oY1qDjxHuToxvJPtxD_s{position:relative}.K_uhm_dJUaXX4bWtajow{padding:0 2px 0 4px}`, "",{"version":3,"sources":["webpack://./src/widgets/CallPopUp/ui/CallMicPopUp/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CAGF,sBACE,mBAAA","sourcesContent":[".wrap {\n  position: relative;\n}\n\n.wrapContent {\n  padding: 0 2px 0 4px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oY1qDjxHuToxvJPtxD_s`,
	"wrapContent": `K_uhm_dJUaXX4bWtajow`
};
export default ___CSS_LOADER_EXPORT___;
